module.exports = __webpack_public_path__ + "static/media/plaque_leclerc23.94e36f2d.png";